import UnclaimedDraftEmbeddedSigning from "components/lib/Shared/ESignature/UnclaimedDraftEmbeddedSigning";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { convertOfficialDetailsToSignerDetails } from "utils/esignature";

const FirstStep = ({
  isDirectorsOnlyFormsUploaded,
  setIsDirectorsOnlyFormsUploaded,
  selectedTabIndex,
  setSelectedTabIndex,
  completeFirstStep,
  directors,
}) => {
  const { company } = useSelector((state) => state.companySlice);
  const [signers, setSigners] = useState([]);

  const directorsOnlyForms = Object.keys(company?.preSignedBusinessDocuments)
    .filter((key) => key !== "formCR2" && key !== "articlesOfAssociation")
    .reverse();

  const fileUrls = directorsOnlyForms.map(
    (form) =>
      `${process.env.REACT_APP_IMAGE_BASE_URL}/images/${company.preSignedBusinessDocuments[form]}`
  );

  const disableTab = () => {
    setIsDirectorsOnlyFormsUploaded(true);
  };

  const goToNextStep = () => {
    completeFirstStep();
    setSelectedTabIndex(selectedTabIndex + 1);
  };

  const functionsToCall = [disableTab, goToNextStep];

  const metadata = {
    fileNames: directorsOnlyForms,
    isDirectorsOnlyEmail: true,
    companyId: company?._id,
  };

  useEffect(() => {
    /** Make sure directors are available */
    if (directors.length > 0) {
      const applicant = convertOfficialDetailsToSignerDetails(
        company?.createdBy
      );
      directors = directors.map((details) =>
        convertOfficialDetailsToSignerDetails(details)
      );
      const isApplicantOfficial = directors.find(
        (signer) =>
          signer.name === applicant.name &&
          signer.emailAddress === applicant.emailAddress
      );

      if (!isApplicantOfficial) {
        setSigners([applicant, ...directors]);
      } else {
        setSigners([...directors]);
      }
    }
  }, [directors]);

  if (isDirectorsOnlyFormsUploaded === true) {
    return (
      <div>
        <h1>You have already uploaded Directors only forms</h1>
      </div>
    );
  } else if (signers.length > 0) {
    return (
      <div>
        <UnclaimedDraftEmbeddedSigning
          signers={signers}
          fileUrls={fileUrls}
          metadata={metadata}
          functionsToCall={functionsToCall}
        />
      </div>
    );
  } else {
    return <div>Getting signers........</div>;
  }
};

export default FirstStep;
